// 鶏の一戦の爪の突っ込みで跳ぶ高さ (DEV・10-29)。src/rooster_fight.ts が入れ、src/boss.ts の踏み込みが読む。
//   boss.ts から rooster_fight.ts (絵・定義を読む) を直に読むと読み込み順が回って壊れるので、何も読まない小さな箱に分けた。
// 10-30 作者 R-2「跳びが小さくて正直よーく見比べないとわからなかった」→ 22 から体の高さ 180 の約 1/3 へ。
export const ROOSTER_CLAW_HOP_PX = 56
let ids: ReadonlySet<string> = new Set()
let hopPx = ROOSTER_CLAW_HOP_PX
/** px は比べる撮影 (scripts/capture_rooster_toki_1030.mjs) で前の高さを出す時だけ渡す。 */
/** 爪の突っ込みで跳ぶ高さ (一戦の時の鶏の爪だけ。ほかは 0)。 */
let byTimeIds: ReadonlySet<string> = new Set()
/** 時間で跳ぶ時の踏み切り (当たりの頭の何 ms 前)。頂点は当たりの頭の少し後、当たりの終わりで着地。 */
export const ROOSTER_CLAW_HOP_LEAD_MS = 120
/** px・byTime は比べる撮影 (scripts/capture_rooster_toki_1030.mjs) で前の高さと形を出す時だけ渡す。
 *  byTimeIds = 時間で跳ぶ技。爪の1発ごとに跳ぶ (10-30 R-2: 踏み込んだ距離で跳ぶ形は1発目の約 100ms しか跳ばず、2・3発目は跳ばなかった)。 */
export function setRoosterClawHop(attackIds: readonly string[], px = ROOSTER_CLAW_HOP_PX, timeIds: readonly string[] = []): void {
  ids = new Set(attackIds); hopPx = px; byTimeIds = new Set(timeIds)
}
/** 踏み込んだ距離で跳ぶ高さ (src/boss.ts が読む。時間で跳ぶ技とほかの技は 0)。 */
export function roosterClawHopPx(attackId: string): number { return ids.has(attackId) && !byTimeIds.has(attackId) ? hopPx : 0 }

type HopBoss = { state: string; stateElapsed: number; comboHitIndex: number; altitudePx?: number
  currentAttack: { id: string; chargeMs: number; activeMs: number; comboGapMs?: number; comboGapsMs?: number[] } | null }
/** 時間で跳ぶ技の高さを boss に書く (src/game.ts が updateBoss の後にかける)。当たりの頭の 120ms 前に踏み切り、当たりの終わりで着地。 */
export function withRoosterClawHop<B extends HopBoss>(boss: B): B {
  const atk = boss.currentAttack
  if (!atk || !byTimeIds.has(atk.id)) return boss
  const el = boss.stateElapsed * 1000
  // 当たりの頭からの経過 (前なら負)。
  let t: number | null = null
  if (boss.state === 'telegraph') t = el - atk.chargeMs
  else if (boss.state === 'comboGap') t = el - (atk.comboGapsMs?.[boss.comboHitIndex] ?? atk.comboGapMs ?? 0)
  else if (boss.state === 'active') t = el
  const span = ROOSTER_CLAW_HOP_LEAD_MS + atk.activeMs
  const u = t === null ? -1 : (t + ROOSTER_CLAW_HOP_LEAD_MS) / span
  const alt = u > 0 && u < 1 ? hopPx * Math.sin(Math.PI * u) : 0
  return (boss.altitudePx ?? 0) === alt ? boss : { ...boss, altitudePx: alt }
}
